import { createIcon } from '../icon'
import CheckIcon from '../svg/CheckIcon'

export const CheckIconDefault = createIcon(CheckIcon)
